<template>
  <div class="frame">
    <!-- 手机端 侧边导航栏 -->
    <div class="m-st-nav">
      <div class="top">
        <div class="name">伞塔食品</div>
        <div class="text">传承历史悠久的川菜调味品牌</div>
      </div>
      <ul class="nav">
        <li
          :class="['list', item.routeName == $route.path ? 'on' : '']"
          v-for="item in $store.state.navList"
          :key="item.id"
          @click="changeNav(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <!-- body 部分 -->
    <div :class="['st-body', show ? 'translate' : '']" @click="show = false">
      <div class="white" v-show="show"></div>
      <Top @openShow="openShow"></Top>
      <div class="frame-body">
        <router-view />
      </div>
      <Foot></Foot>
    </div>
  </div>
</template>

<script>
import Top from "@/components/top.vue";
import Foot from "@/components/foot.vue";
export default {
  data() {
    return {
      show: false,
    };
  },
  components: {
    Top,
    Foot,
  },
  created() {},
  mounted() {},
  methods: {
    openShow() {
      this.show = true;
    },
    changeNav(val) {
      this.$store.commit("SET_INFO", { code: val.code, name: val.name });
      this.$store.commit("SET_SUBLIST", { subList: val.children });
      window.scrollTo(0, 0);
      // 路由跳转
      if (val.routeName !== this.$route.path) {
        this.$router.push(val.routeName);
      } else {
        this.reload();
      }
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  width: 100vw;
  overflow-x: hidden;
}
.frame-body {
  min-height: calc(100vh - 130px - 90px);
}
.m-st-nav {
  display: none;
  width: 250px;
  height: 100vh;
  background-color: #f1eaec;
  box-shadow: inset -4px 0 17px 0 rgba(0, 0, 0, 0.35);
  position: fixed;
  left: 0;
  top: 0;

  .top {
    color: #fff;
    background-color: #cc0f16;
    padding: 20px 18px;
    font-size: 0.28rem;

    .name {
      margin-bottom: 2px;
      font-weight: bold;
    }
    .text {
      font-size: 0.27rem;
      font-weight: 100;
      opacity: 0.6;
    }
  }
  .nav {
    font-size: 0.28rem;
    .list {
      padding: 15px 20px;
      color: #666666;
      border-bottom: 1px solid;
      border-color: rgba($color: #fff, $alpha: 0.5);
    }
    .on {
      color: $theme;
    }
  }
}
.st-body {
  transition: all 0.3s;
  position: relative;
  background-color: #ffffff;
  &::before {
    content: "";
    display: table;
  }

  .white {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    background-color: rgba($color: #ffffff, $alpha: 0.5);
  }
}
.translate {
  transform: translateX(250px);
}
@media (max-width: 1300px) {
  .frame-body {
    min-height: auto;
  }
}
@media (max-width: 1024px) {
  .m-st-nav {
    display: block;
  }
}
</style>
